import { NgClass } from '@angular/common'
import { Component, EventEmitter, Input, Output } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { SvgIconComponent } from 'angular-svg-icon'

let nextId = 0

export type ValueFilterOption = {
  label: string
  value: string
  count?: number
  icon?: string
  status?: 'error' | 'info' | 'notice' | 'success' | 'warning'
}

@Component({
  selector: 'app-value-filter',
  imports: [FormsModule, NgClass, SvgIconComponent],
  templateUrl: './value-filter.component.html',
})
export class ValueFilterComponent {
  @Input({ required: false }) public name: string = `rg-${++nextId}`
  @Input({ required: true }) public selected!: string
  @Input({ required: false }) public isLoading: boolean = false
  @Input({ required: true }) public options!: ValueFilterOption[]
  @Output() public selectionChange = new EventEmitter<string>()

  public onChange(val: string): void {
    this.selected = val
    this.selectionChange.emit(val)
  }
}
